<template>
  <div class="draw">

    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover">
    </head>
    <v-app>
      <v-container>
        <v-row id="canv" class="d-flex justify-center">
          <div>
            <canvas id="imgCanvas" ref="imgCanvas" style="
              /* aspect-ratio: DEFAULT_CANVAS_WIDTH/DEFAULT_CANVAS_HEIGHT;
              width: 95vw; */
              top: 0px;
              right: 0;
              bottom: 0;
              left: 0;
              margin: 0 auto;
              position:relative;
              border: 1px solid black;
            "></canvas>

            <canvas id="drawCanvas" ref="drawCanvas" style="
                /* aspect-ratio: DEFAULT_CANVAS_WIDTH/DEFAULT_CANVAS_HEIGHT;
                width: 95vw; */
                top: 0px;
                right: 0px;
                left: 0px;
                margin: 0 auto;
                position: absolute;
                border: 1px solid black;
              "></canvas>
            <!-- <canvas id="brushCanvas" ref="brushCanvas" width="50" height="50" style="
                top: 0px;
                right: 0px;
                bottom: 0px;
                left: 330px;
                position: absolute;
                border: 1px solid black;
              "></canvas> -->
            <canvas v-show="isPartMode" id="partCanvas" ref="partCanvas" style="
                /* aspect-ratio: DEFAULT_CANVAS_WIDTH / DEFAULT_CANVAS_HEIGHT;
                width: 95vw; */
                top: 0px;
                right: 0px;
                left: 0px;
                margin: 0 auto;
                position: absolute;
                border: 2px solid rgb(42, 125, 232);
                background-color: rgb(42, 125, 232,0.1);
              "></canvas>
          </div>
        </v-row>

        <v-row>
          <v-col>
            <!-- <v-row>
              <v-col cols="2" class="pt-1 pl-3">
                太さ:
              </v-col>
              <v-col cols="10" class="pt-0 pl-0">
                <v-slider hide-details v-model="slider" max="30" min="1" v-on:change="sizeChange(slider)"></v-slider>
              </v-col>
            </v-row> -->
            <v-col class="px-5 mt-2">
              <v-row>
                <v-btn id="btnUndo" @click="btnUndo" rounded outlined color="blue"><v-icon>mdi-undo</v-icon>{{
                  $t('draw.undo') }}</v-btn>
                <v-spacer></v-spacer>
                <!-- <v-btn id="btnClear" @click="btnClear" rounded outlined color="amber">クリア</v-btn> -->
                <!-- <v-spacer></v-spacer><v-spacer></v-spacer><v-spacer></v-spacer> -->
                <!-- <v-btn @click="sendDB" rounded color="primary">完成！</v-btn> -->


                <!-- <Modal @click="getUrl" :imgUrl="this.imgURL"></Modal> -->
                <div id="modal">
                  <v-dialog v-model="dialog" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <!-- <v-btn color="amber" dark v-bind="attrs" v-on="on" rounded @click="getUrl"> -->
                      <v-btn color="blue" dark v-bind="attrs" v-on="on" rounded @click="getUrl(); toSearch()">
                        {{ $t('draw.complete') }}
                      </v-btn>
                    </template>

                    <!-- <v-card>
                      <v-card-title class="blue lighten-2 white--text">
                        かんせいしたぬりえ
                      </v-card-title>
                      <div class="imgBox">
                        <v-img max-width="100%" src="https://dev.pensaku.com/img/penguin_backimg1.png" style="
                          top: 0px;
                          right: 0px;
                          bottom: 0px;
                          left: 0px;
                          position: absolute;
                        "></v-img>
                        <v-img max-width="100%" :src="this.imgURL" style="
                          top: 0px;
                          right: 0px;
                          bottom: 0px;
                          left: 0px;
                          position: absolute;
                        "></v-img>
                      </div>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn color="primary" text @click="toSearch()" block>
                          ペンギンをさがす
                        </v-btn>
                      </v-card-actions>
                      <v-card-actions>
                        <v-btn color="primary" text @click="dialog = false" block>
                          もうすこしかく
                        </v-btn>
                      </v-card-actions>
                    </v-card> -->
                  </v-dialog>
                </div>
              </v-row>
              <v-row>
                <!-- <v-btn color="light-blue" dark rounded @click="changePartMode()" class="mt-5">みえないところ</v-btn> -->
                <v-btn color="blue" rounded outlined @click="changePartMode()" class="mt-5">{{ $t('draw.invisibleParts')
                }}</v-btn>
              </v-row>
            </v-col>

            <!-- <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            <div class="col-6 text-right">
              x:<span ref="dispX">0</span> y:<span ref="dispY">0</span>
            </div> -->

          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import UndoCanvas from "undo-canvas";
import { fire, getPrevScreen, setCurrentScreen } from '@/utils/logger';
// import Modal from "../components/modal.vue";

const DEFAULT_CANVAS_WIDTH = 380;
const DEFAULT_CANVAS_HEIGHT = 410;

export default {
  props: ['aquarium'],
  name: "DP",
  data() {
    return {
      startX: 0, // 開始座標(X)
      startY: 56, // 開始座標(Y)
      brushSize: 10, //ペンの太さ
      holdClick: false, // クリックホールドフラグ
      data: [],
      pos: [],
      temp: 0,
      pos_temp: [],
      slider: 10,
      isFirstTap: true,
      undoCount: 0, //連続で押した回数
      defaultCanvasWidth: DEFAULT_CANVAS_WIDTH,
      defaultCanvasHeight: DEFAULT_CANVAS_HEIGHT,
      canvasLeft: 0,
      canvasTop: 0,
      canvasWidth: 100,
      canvasHeight: 100,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      // zoomRatio: 1,
      imgURL: "",
      blob: "",
      dialog: false,
      dialog_part: false,
      startTime: 0,
      endTime: 0,
      drawTime: 0,
      // plot_vector: [0, 0, 0, 0, 0, 0, 0, 0, 0], //9分割にしたエリアのどこに描いているかを格納する配列
      // area_temp: [], //どのエリアに描いたかをpushしていく配列（undo対応のため）
      div_rectX: 160, //お腹を抽出する四角形の横幅
      div_rectY: 216, //お腹を抽出する四角形の縦幅
      div_sizeX: 3, //四角形を横に何分割するか
      div_sizeY: 3, //四角形を縦に何分割するか
      div_upperLeftX: 115, //お腹を抽出する四角形の左上のx座標
      div_upperLeftY: 135, //お腹を抽出する四角形の左上のy座標
      part: [1, 1, 1, 1, 1, 1, 1, 1, 1], //見えたエリアがどこかを格納する配列（見えなければ-1）
      isPartMode: false,
      // ---- ↓logging 用 ----
      drawingId: crypto.randomUUID(),
      viewId: null,
      viewStart: 0,
      activeStart: 0,
      activeTotal: 0,
      moveBuf: [],           // stroke_move をバッチ化
      lastMoveFlushAt: 0,
      strokeSeq: 0,          // ストローク番号
      // ↓ グリッド管理用
      plot_vector: [],
      area_temp: [],
      gridSizes: [2, 3, 4, 5],
      plotVectorsByN: {},   // {2:[...],3:[...],4:[...],5:[...]}
      areaTempByN: {},      // {2:[],3:[],4:[],5:[]}
      partByN: {},         // 見えないところ用{2:[...],3:[...],4:[...],5:[...]
    };
  },
  computed: {
    divRectX: function () {
      return this.normalizePos(this.div_rectX, DEFAULT_CANVAS_WIDTH, this.canvasWidth);
    },
    divRectY: function () {
      return this.normalizePos(this.div_rectY, DEFAULT_CANVAS_HEIGHT, this.canvasHeight);
    },
    divUpperLeftX: function () {
      return this.normalizePos(this.div_upperLeftX, DEFAULT_CANVAS_WIDTH, this.canvasWidth);
    },
    divUpperLeftY: function () {
      return this.normalizePos(this.div_upperLeftY, DEFAULT_CANVAS_HEIGHT, this.canvasHeight);
    },
  },
  components: {
    // Modal,
  },
  mounted() {
    // スクロールをロックする
    this.$noScroll();
    // ダブルタップを無効にする
    document.addEventListener('dblclick', function (e) {
      e.preventDefault();
    });

    // ---- ログ page_view(draw) ----
    this.viewId = crypto.randomUUID();
    this.viewStart = performance.now();
    this.activeStart = performance.now();
    this.activeTotal = 0;
    fire('page_view', {
      view_id: this.viewId,
      screen: 'draw',
      from: getPrevScreen(),
      locale: this.$i18n.locale,
      aquarium: this.aquarium,
    });
    setCurrentScreen('draw');
    document.addEventListener('visibilitychange', this._onVis);
    window.addEventListener('beforeunload', this._flushLeave, { once: true });

    const w = window.innerWidth * 0.95;
    const h = w * DEFAULT_CANVAS_HEIGHT / DEFAULT_CANVAS_WIDTH;
    this.imgCvs = this.$refs.imgCanvas;
    this.imgCvs.width = w;
    this.imgCvs.height = h;
    this.imgCtx = this.imgCvs.getContext("2d");
    this.drawCvs = this.$refs.drawCanvas;
    this.drawCvs.width = w;
    this.drawCvs.height = h;
    this.drawCtx = this.drawCvs.getContext("2d");
    const imgBounds = this.imgCvs.getBoundingClientRect();
    this.startX = imgBounds.left;
    this.startY = imgBounds.top;
    // this.brushCvs = this.$refs.brushCanvas;
    // this.brushCtx = this.brushCvs.getContext("2d");
    this.partCvs = this.$refs.partCanvas;
    this.partCvs.width = w;
    this.partCvs.height = h;
    this.partCtx = this.partCvs.getContext("2d");
    /// UndoCanvasを初期化
    UndoCanvas.enableUndo(this.drawCtx);
    this.updateCanvasRect();
    //canvasを使っている端末の画面いっぱいに表示する
    // this.imgCvs.setAttribute("width", this.windowWidth);
    // this.drawCvs.setAttribute("width", this.windowWidth);
    // this.imgCvs.setAttribute("height", this.windowWidth);
    // this.drawCvs.setAttribute("height", this.windowWidth);

    // window.addEventListener("load", () => {
    // マウスクリックイベント
    this.drawCvs.addEventListener("touchstart", this.mouseDown);
    this.partCvs.addEventListener("touchstart", this.mouseDownPart);
    // マウス移動イベント
    this.drawCvs.addEventListener("touchmove", this.mouseMove);
    // マウスクリック外しイベント
    this.drawCvs.addEventListener("touchend", this.mouseUp);
    // マウスホイールイベント
    this.drawCvs.addEventListener("wheel", this.mouseWheel);
    // エリアから外れたときのイベント
    this.drawCvs.addEventListener("mouseout", function (e) {
      // ポインター除去
      // this.drawCtx.clearRect(0, 0, this.imgCvs.width, this.imgCvs.height);
      // マウスクリック外しイベントを呼び出し
      if (this.holdClick) {
        this.mouseUp(e);
      }
      //   });
    });

    // this.drawBrushSize(this.brushSize / 2);
  },
  created() {
    this._initGridStores();   // 多段グリッドの配列初期化
    this._rebuildPartByNFrom3();  // 3×3 part から 2/4/5 の partByN を派生生成

    this.image(
      // "https://free-icons.net/wp-content/uploads/2020/05/animal014.png"
      "https://dev.pensaku.com/img/penguin_backimg1.png"
    );
    // this.getTime();
    this.startTime = new Date();

    (async () => {
      const loc = localStorage.getItem('locale') || this.$i18n.locale || 'ja';
      // 水族館ごとの base.json も含めてロード（あなたの実装名に合わせて）
      await this.$store.dispatch('ensureAquariumLoaded', this.aquarium);

      // ロケール辞書は毎回 loc で明示的にロード（条件分岐せず await で確実に）
      await this.$store.dispatch('loadPenguinLocale', loc);
    })();
  },
  beforeDestroy() {
    this._flushLeave();
    document.removeEventListener('visibilitychange', this._onVis);
  },
  methods: {
    image: function (src) {
      var img = new Image();
      img.src = src;

      img.onload = () => {
        // console.log(img.src);
        //   // 画像を縮小して設定
        this.imgCtx.drawImage(
          /////////画像を保存したいときはimgCtxじゃなくてdrawCtxにする！
          img,
          0,
          0,
          this.imgCvs.width,
          this.imgCvs.height
        );
      };
    },

    // すべてのグリッド用の配列を初期化。3×3は既存変数へエイリアスを張る
    _initGridStores() {
      this.plotVectorsByN = {};  // 各グリッドの配列を入れる{2:[...],3:[...],4:[...],5:[...]}
      this.areaTempByN = {};  // Undo用に各グリッドの一時配列を入れる{2:[],3:[],4:[],5:[]}
      for (const n of this.gridSizes) {
        this.plotVectorsByN[n] = Array(n * n).fill(0);  // n×n の各セルを0で初期化
        this.areaTempByN[n] = [];  // 空配列で初期化
      }
      // 3×3だけは既存コード互換のため別名を付ける
      this.plot_vector = this.plotVectorsByN[3];
      this.area_temp = this.areaTempByN[3];
    },

    // (n, x, y) -> その点が属するセルの一次元index（範囲外なら null）
    _cellIndex(n, x, y) {
      const stepX = this.divRectX / n;  // 各グリッドの幅
      const stepY = this.divRectY / n;  // 各グリッドの高さ
      const relX = x - this.divUpperLeftX;  // 左上からのどれだけ右にあるか
      const relY = y - this.divUpperLeftY; // 左上からのどれだけ下にあるか
      if (relX <= 0 || relY <= 0 || relX > this.divRectX || relY > this.divRectY) return null; // 範囲外なら null
      // その点がどの列(i)・行(j)にあるかを計算
      const i = Math.min(Math.floor(relX / stepX), n - 1);
      const j = Math.min(Math.floor(relY / stepY), n - 1);
      return j * n + i;
    },

    // 1ストロークの開始点（＝既存仕様に合わせて pos[0]）で各グリッドのカウントを更新
    _updateGridsForPoint(px, py) {
      for (const n of this.gridSizes) {
        const idx = this._cellIndex(n, px, py); //どのマスに入るか
        if (idx != null) {
          this.plotVectorsByN[n][idx] += 1; // そのマスのカウントを増やす
          this.areaTempByN[n].push(idx); // Undo用にそのマスのindexを記録
        } else {
          // 範囲外は記録しない（undo対象にも入れない）
        }
      }
    },

    // n分割グリッドの (i,j) セル矩形を [x0,y0,x1,y1] で返す。
    _cellRect(n, i, j) {
      const stepX = this.divRectX / n;
      const stepY = this.divRectY / n;
      const x0 = this.divUpperLeftX + i * stepX;
      const y0 = this.divUpperLeftY + j * stepY;
      const x1 = x0 + stepX;
      const y1 = y0 + stepY;
      return [x0, y0, x1, y1];
    },

    // // 矩形aが矩形bに「完全に内包」されているかを判定。
    // // eps は境界の浮動小数揺れ対策のほんの少しの許容。
    // _fullyCovered(a, b, eps = 1e-6) {
    //   const [ax0, ay0, ax1, ay1] = a;
    //   const [bx0, by0, bx1, by1] = b;
    //   return ax0 >= bx0 - eps && ay0 >= by0 - eps &&
    //     ax1 <= bx1 + eps && ay1 <= by1 + eps;
    // },

    // rect(対象セル) が 3×3 の不可視セルで完全に覆われているか
    _isCoveredByInvisible3(rect, eps = 1e-6) {
      const [x0, y0, x1, y1] = rect;

      // 3×3 基準
      const n = 3;
      const stepX = this.divRectX / n;
      const stepY = this.divRectY / n;

      // 対象セルを 3×3 グリッド座標系に正規化（矩形範囲を 0..divRectX/Y に切り詰め）
      const rx0 = Math.max(0, x0 - this.divUpperLeftX);
      const ry0 = Math.max(0, y0 - this.divUpperLeftY);
      const rx1 = Math.min(this.divRectX, x1 - this.divUpperLeftX);
      const ry1 = Math.min(this.divRectY, y1 - this.divUpperLeftY);

      // 対象セルが跨る 3×3 セルの i/j 範囲を求める（右/下端は -eps で隣セルに入らないように）
      const i0 = Math.floor((rx0 + eps) / stepX);
      const j0 = Math.floor((ry0 + eps) / stepY);
      const i1 = Math.floor((rx1 - eps) / stepX);
      const j1 = Math.floor((ry1 - eps) / stepY);

      // 範囲が妥当かチェック
      if (i0 > i1 || j0 > j1) return false;
      if (i0 < 0 || j0 < 0 || i1 > n - 1 || j1 > n - 1) return false;

      // 跨っているすべての 3×3 セルが不可視(-1)なら「合併で完全被覆」とみなす
      for (let j = j0; j <= j1; j++) {
        for (let i = i0; i <= i1; i++) {
          const idx = j * n + i;
          if (this.part[idx] !== -1) return false;
        }
      }
      return true;
    },

    // 現在の 3×3 part（-1 のセル）を矩形配列として収集。
    _invisibleRectsFrom3x3() {
      const rects = [];
      const n = 3;
      for (let j = 0; j < n; j++) {
        for (let i = 0; i < n; i++) {
          const idx = j * n + i;
          if (this.part[idx] === -1) {
            rects.push(this._cellRect(n, i, j));
          }
        }
      }
      return rects;
    },

    // 3×3 UIで指定された不可視(-1)セルに「完全内包」されるセルは -1、それ以外は 1。
    // 3×3 は従来通り this.part をそのまま採用。2/4/5 をここで派生生成する。
    _rebuildPartByNFrom3() {
      // 3×3は既存 part をそのまま参照（後方互換のため）
      this.partByN[3] = this.part;

      // gridSizes 例: [2,3,4,5]
      for (const n of this.gridSizes) {
        if (n === 3) continue; // 3×3は上で済み（partByN[3] = part）

        // デフォルトは可視(1)
        const arr = new Array(n * n).fill(1);

        for (let j = 0; j < n; j++) {
          for (let i = 0; i < n; i++) {
            const idx = j * n + i;
            const rect = this._cellRect(n, i, j);

            // 対象セルが跨る3×3セルが「すべて」不可視なら不可視(-1)
            if (this._isCoveredByInvisible3(rect)) {
              arr[idx] = -1;
            }
          }
        }
        this.partByN[n] = arr;
      }
    },

    // 見えないところで指定した部分の黒塗りを更新
    _renderPartMaskFromState() {
      // キャンバス実サイズを更新
      this.updateCanvasRect();

      // いったん全消去
      this.partCtx.clearRect(0, 0, this.canvasWidth * 10, this.canvasHeight * 10);

      this.drawFrame();

      // 3x3 グリッドの各セルを part に合わせて黒塗り
      const n = 3;
      const stepX = this.divRectX / n;
      const stepY = this.divRectY / n;

      for (let j = 0; j < n; j++) {
        for (let i = 0; i < n; i++) {
          const idx = j * n + i;
          if (this.part[idx] === -1) {
            const x = i * stepX + this.divUpperLeftX;
            const y = j * stepY + this.divUpperLeftY;
            this.drawRect(x, y, stepX, stepY);
          }
        }
      }
      // ★最後にヒントテキストを重ね描き（黒塗り・枠の上に表示）
      const fontSize = Math.max(15 * this.canvasWidth / DEFAULT_CANVAS_WIDTH, 15);
      this.partCtx.save();
      this.partCtx.textAlign = "center";
      this.partCtx.textBaseline = "alphabetic";
      this.partCtx.font = `${fontSize}px Fira Sans`;
      this.partCtx.fillStyle = "#000";
      this.partCtx.globalAlpha = 1;
      this.partCtx.fillText(this.$t('draw.tapHint'), this.canvasWidth / 2, 20 + fontSize / 2);
      this.partCtx.restore();
    },


    drawPen: function (e) {
      // var rect = e.target.getBoundingClientRect();
      this.drawCtx.lineWidth = this.brushSize;
      // this.drawCtx.strokeStyle = canvasRgba;
      this.drawCtx.lineJoin = "round";
      this.drawCtx.lineCap = "round";
      this.drawCtx.globalCompositeOperation = "source-over";
      // this.drawCtx.putTag();
      this.drawCtx.beginPath();
      this.drawCtx.moveTo(this.startX, this.startY); // 開始座標（前回座標）
      this.drawCtx.lineTo(
        e.changedTouches[0].clientX - this.canvasLeft,
        e.changedTouches[0].clientY - this.canvasTop
      ); // 終了座標（現在座標）
      // this.drawCvs.setAttribute("width", 200);
      this.drawCtx.stroke(); // 直線を描画
      this.drawCtx.closePath();

      // 次の描画に向けて現在の座標を保持（開始・終了を同じ座標で描画すると、マウスを高速に移動したときに歯抜け状態になる）
      this.startX = e.changedTouches[0].clientX - this.canvasLeft;
      this.startY = e.changedTouches[0].clientY - this.canvasTop;
    },

    // 太さ変更時
    // sizeChange: function (num) {
    //   this.$refs.size.innerHTML = num;
    //   this.brushSize = num;
    //   this.drawBrushSize(this.slider / 2);
    // },

    //太さをcanvasに表示
    // drawBrushSize: function (radius) {
    //   this.brushCtx.beginPath();
    //   this.brushCtx.clearRect(0, 0, 50, 50);
    //   this.brushCtx.fillStyle = "black";
    //   this.brushCtx.arc(
    //     25, //中心点X
    //     25, //中心点Y
    //     radius, //半径(radius)
    //     0, //円の描画開始角度(startAngle)
    //     2 * Math.PI //円の描画終了角度(endAngle)
    //   );
    //   this.brushCtx.fill();
    // },

    //Undo
    btnUndo: function () {
      // if (this.isFirstTap == true) {
      //   this.undoCount++;
      //   this.drawCtx.undoTag();
      //   // this.drawCtx.undoTag();
      //   this.isFirstTap = false;
      //   this.data.pop();
      //   this.plot_vector[this.area_temp.slice(-1)[0]] -= 1;
      //   this.area_temp.pop();
      // } else {
      //   this.undoCount++;
      //   this.drawCtx.undoTag();
      //   this.isFirstTap = false;
      //   this.data.pop();
      //   this.plot_vector[this.area_temp.slice(-1)[0]] -= 1;
      //   this.area_temp.pop();
      // }

      // キャンバスのUndo（見た目）
      this.undoCount++;
      this.drawCtx.undoTag();
      this.isFirstTap = false;
      // ストローク履歴からも削除
      this.data.pop();
      // 多段グリッドのUndo
      for (const n of this.gridSizes) {
        const stack = this.areaTempByN[n];
        const vec = this.plotVectorsByN[n];
        const last = stack.pop();      // 最後に +1 したセル
        if (last != null && last >= 0) {
          vec[last] = Math.max(0, vec[last] - 1);
        }
      }

      // ---- ログ undo ----
      // const totalPoints = this.data.reduce((s, d) => s + (d.pos?.length || 0), 0);
      fire('undo', {
        drawing_id: this.drawingId,
        total_strokes: this.data.length,
      });
    },

    //Redo
    btnRedo: function () {
      this.drawCtx.redoTag();
    },

    //Clear
    btnClear: function () {
      this.drawCtx.clearRect(0, 0, DEFAULT_CANVAS_WIDTH, DEFAULT_CANVAS_HEIGHT);
      this.data.splice(0);
      // this.plot_vector = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      // this.area_temp.splice(0);
      this._initGridStores();   // 多段グリッドの配列初期化
      this.image(
        // "https://free-icons.net/wp-content/uploads/2020/05/animal014.png"
        "https://dev.pensaku.com/img/penguin_backimg1.png"
      );
    },

    drawpartCtx: function () {
      this.updateCanvasRect();
      this.partCtx.clearRect(0, 0, this.canvasWidth * 10, this.canvasHeight * 10);
      this.partCtx.textAlign = "center";
      const fontSize = Math.max(15 * this.canvasWidth / DEFAULT_CANVAS_WIDTH, 15);
      this.partCtx.font = `${fontSize}px Fira Sans`;
      this.partCtx.fillText(this.$t('draw.tapHint'), this.canvasWidth / 2, 20 + fontSize / 2);
      this.drawFrame();
    },

    // 見えなかった部分の枠を表示
    drawFrame: function () {
      let stepX = this.divRectX / 3;
      let stepY = this.divRectY / 3;
      let x = this.divUpperLeftX;
      let y = this.divUpperLeftY;
      // console.log(stepX, stepY, x, y);
      this.partCtx.strokeStyle = "blue";
      for (let i = 0; i < 4; i++) {
        this.partCtx.beginPath();
        this.partCtx.moveTo(x, y);
        this.partCtx.lineTo(x + this.divRectX, y);
        this.partCtx.stroke();
        y += stepY;
      }
      y = this.divUpperLeftY;
      for (let j = 0; j < 4; j++) {
        this.partCtx.beginPath();
        this.partCtx.moveTo(x, y);
        this.partCtx.lineTo(x, y + this.divRectY);
        this.partCtx.stroke();
        x += stepX;
      }
    },

    // 見えなかった部分を黒くする
    drawRect: function (x, y, w, h) {
      this.partCtx.beginPath();
      this.partCtx.fillStyle = 'rgba(0,0,0,0.4)';
      this.partCtx.fillRect(x, y, w, h);
      this.partCtx.stroke();
    },

    removeRect: function (x, y, w, h) {
      this.partCtx.clearRect(x, y, w, h);
      this.drawFrame();
    },

    updateCanvasRect: function () {
      this.canvasLeft = this.drawCvs.getBoundingClientRect().left;
      this.canvasTop = this.drawCvs.getBoundingClientRect().top;
      this.canvasWidth = this.imgCvs.clientWidth;
      this.canvasHeight = this.imgCvs.clientHeight;
    },

    normalizePos: function (value, from, to) {
      return value / from * to
    },

    // ---- ログ page_leave(active_ms 計測) ----
    _onVis() {
      const now = performance.now();
      if (document.visibilityState === 'hidden') {
        this.activeTotal += now - this.activeStart;
      } else if (document.visibilityState === 'visible') {
        this.activeStart = now;
      }
    },
    _flushLeave() {
      if (!this.viewStart || this.viewLeft) return;
      this.viewLeft = true;
      const now = performance.now();
      const total = now - this.viewStart;
      if (document.visibilityState === 'visible') {
        this.activeTotal += now - this.activeStart;
      }
      fire('page_leave', {
        view_id: this.viewId,
        screen: 'draw',
        total_ms: Math.round(total),
        active_ms: Math.round(this.activeTotal)
      });
      // 送信しきれていない move バッファがあれば最後に吐く（任意）
      if (this.moveBuf.length) {
        fire('stroke_move', { drawing_id: this.drawingId, points: this.moveBuf.slice(0) });
        this.moveBuf.length = 0;
      }
    },

    // マウスクリックイベント(範囲指定のとき用)
    mouseDownPart: function (e) {
      this.updateCanvasRect();
      this.startX = e.touches[0].clientX - this.canvasLeft;
      this.startY = e.touches[0].clientY - this.canvasTop;

      let stepX = this.divRectX / 3
      let stepY = this.divRectY / 3
      for (let i = 0; i < 3; i++) {
        if ((this.startX > i * stepX + this.divUpperLeftX) && (this.startX <= (i + 1) * stepX + this.divUpperLeftX)) {
          for (let j = 0; j < 3; j++) {
            if ((this.startY > j * stepY + this.divUpperLeftY) && (this.startY <= (j + 1) * stepY + this.divUpperLeftY)) {
              this.part[j * 3 + i] = this.part[j * 3 + i] * (-1);
              // console.log(this.part);
              // console.log(j * stepY + this.divUpperLeftY);
              // console.log(this.startX,this.startY,":",i * stepX + this.divUpperLeftX,j * stepY + this.divUpperLeftY)
              if (this.part[j * 3 + i] == -1) {
                this.drawRect(i * stepX + this.divUpperLeftX, j * stepY + this.divUpperLeftY, stepX, stepY);
              }
              else {
                this.removeRect(i * stepX + this.divUpperLeftX - 1, j * stepY + this.divUpperLeftY - 1, stepX + 2, stepY + 1);
              }
              // 3×3の変更を元に 2/4/5 の partByN を再構築（完全内包セルは -1）
              this._rebuildPartByNFrom3();
              // 3x3 の黒塗りを、現在の part 状態から全体再描画
              this._renderPartMaskFromState();
              // console.log(this.partByN);

              // 見えないエリアの変更ログ（トグルごと）
              fire('part_toggle', {
                drawing_id: this.drawingId,
                part: this.part.slice(0)
              });
            }
          }
        }
      }
    },

    // マウスクリックイベント
    mouseDown: function (e) {
      // var rect = e.target.getBoundingClientRect();
      this.updateCanvasRect();
      //   console.log(this.canvasLeft, this.canvasTop);
      this.pos = [];
      this.holdClick = true;
      this.isFirstTap = true;
      this.undoCount = 0;
      // クリック開始座標を保持
      this.startX = e.touches[0].clientX - this.canvasLeft;
      this.startY = e.touches[0].clientY - this.canvasTop;
      this.pos.push({
        x: this.normalizePos(e.touches[0].clientX - this.canvasLeft, this.canvasWidth, DEFAULT_CANVAS_WIDTH),
        y: this.normalizePos(e.touches[0].clientY - this.canvasTop, this.canvasHeight, DEFAULT_CANVAS_HEIGHT),
      });
      // console.log("client", this.normalizePos(e.touches[0].clientX - this.canvasLeft, this.canvasWidth, DEFAULT_CANVAS_WIDTH),
      //   this.normalizePos(e.touches[0].clientY - this.canvasTop, this.canvasHeight, DEFAULT_CANVAS_HEIGHT));
      // console.log("page", this.normalizePos(e.touches[0].pageX - this.canvasLeft, this.canvasWidth, DEFAULT_CANVAS_WIDTH),
      //   this.normalizePos(e.touches[0].pageY - this.canvasTop, this.canvasHeight, DEFAULT_CANVAS_HEIGHT));
      this.temp++;
      this.drawCtx.putTag();
      // ---- ログ stroke_start ----
      this.strokeSeq++;
      this.moveBuf.length = 0;
      this.lastMoveFlushAt = performance.now();
      fire('stroke_start', {
        drawing_id: this.drawingId,
        seq: this.strokeSeq,
        x: this.pos[0].x,
        y: this.pos[0].y,
        pen_px: this.brushSize
      });
    },

    // マウス移動イベント
    mouseMove: function (e) {
      // var rect = e.target.getBoundingClientRect();
      // var x = e.pageX - rect.left;
      // var y = e.pageY - rect.top;
      // console.log(rect.top);
      // // 座標表示
      // this.$refs.dispX.innerHTML = e.offsetX;
      // this.$refs.dispY.innerHTML = e.offsetY;

      // if (mode == "1") {
      //   // モード：描く

      //   if (inputType == "1" || inputType == "2") {
      //     // 描き込みタイプ：ペン or 直線
      //     pointer(e);
      //   }

      if (this.holdClick) {
        this.pos_temp.splice(0);
        //   if (inputType == "1") {
        //     // 描き込みタイプ：ペン
        this.drawPen(e);
        // this.drawCtx.putTag();
        // 座標表示
        // this.$refs.dispX.innerHTML =
        //   e.changedTouches[0].pageX - this.canvasLeft;
        // this.$refs.dispY.innerHTML = e.changedTouches[0].pageY - this.canvasTop;
        // this.pos[stroke] = this.temp;
        // this.pos[zahyo] = { x: e.offsetX, y: e.offsetY };
        const px = this.normalizePos(e.changedTouches[0].clientX - this.canvasLeft, this.canvasWidth, DEFAULT_CANVAS_WIDTH);
        const py = this.normalizePos(e.changedTouches[0].clientY - this.canvasTop, this.canvasHeight, DEFAULT_CANVAS_HEIGHT);
        this.pos.push({ x: px, y: py }); //ドラッグしてるときの最初の座標のみを配列に追加（タップの場合はドラッグ中の座標だけ）
        this.pos_temp.push({ x: px, y: py });
        // ---- ログ stroke_move（バッチ送信）----
        this.moveBuf.push({ x: px, y: py });
        const now = performance.now();
        if (this.moveBuf.length >= 12 || now - this.lastMoveFlushAt > 120) {
          fire('stroke_move', { drawing_id: this.drawingId, points: this.moveBuf.slice(0) });
          this.moveBuf.length = 0;
          this.lastMoveFlushAt = now;
        }
      }
    },

    // マウスクリック外しイベント
    mouseUp: function (e) {
      // var rect = e.target.getBoundingClientRect();
      e.preventDefault();
      this.holdClick = false;
      this.drawPen(e); /////////////
      // 点描画
      this.drawCtx.beginPath();
      this.drawCtx.fillStyle = "black";
      this.drawCtx.arc(
        e.changedTouches[0].clientX - this.canvasLeft, //中心点X
        e.changedTouches[0].clientY - this.canvasTop, //中心点Y
        this.brushSize / 2, //半径(radius)
        0, //円の描画開始角度(startAngle)
        2 * Math.PI //円の描画終了角度(endAngle)
      );
      this.drawCtx.fill();

      // this.temp++;
      // this.drawCtx.putTag();
      //   console.log("aaa"); //離した瞬間
      // 座標表示
      // this.$refs.dispX.innerHTML = e.changedTouches[0].pageX - this.canvasLeft;
      // this.$refs.dispY.innerHTML = e.changedTouches[0].pageY - this.canvasTop;
      this.pos.push({
        x: this.normalizePos(e.changedTouches[0].clientX - this.canvasLeft, this.canvasWidth, DEFAULT_CANVAS_WIDTH),
        y: this.normalizePos(e.changedTouches[0].clientY - this.canvasTop, this.canvasHeight, DEFAULT_CANVAS_HEIGHT),
      }); //ドラッグしてるときの座標を配列に追加（タップの時は離した時の座標のみ）
      this.pos_temp.push({
        x: this.normalizePos(e.changedTouches[0].clientX - this.canvasLeft, this.canvasWidth, DEFAULT_CANVAS_WIDTH),
        y: this.normalizePos(e.changedTouches[0].clientY - this.canvasTop, this.canvasHeight, DEFAULT_CANVAS_HEIGHT),
      });
      this.data.push({
        stroke: this.temp,
        brushSize: this.brushSize,
        pos: this.pos,
      });
      // let stepX = this.divRectX / 3
      // let stepY = this.divRectY / 3
      // for (let i = 0; i < 3; i++) {
      //   // console.log(this.pos[0].x)
      //   if ((this.pos[0].x > i * stepX + this.divUpperLeftX) && (this.pos[0].x <= (i + 1) * stepX + this.divUpperLeftX)) {
      //     for (let j = 0; j < 3; j++) {
      //       if ((this.pos[0].y > j * stepY + this.divUpperLeftY) && (this.pos[0].y <= (j + 1) * stepY + this.divUpperLeftY)) {
      //         this.plot_vector[j * 3 + i]++;
      //         // console.log(this.plot_vector)
      //         this.area_temp.push(j * 3 + i)
      //         // console.log(this.area_temp)
      //       }
      //     }
      //   }
      // }
      // --- 多段グリッド更新（開始点 pos[0] 基準） ---
      if (this.pos && this.pos[0]) {
        const p0 = this.pos[0];
        this._updateGridsForPoint(p0.x, p0.y);
      }
      // console.log(this.plotVectorsByN);


      // ログ move の残りを吐く
      if (this.moveBuf.length) {
        fire('stroke_move', { drawing_id: this.drawingId, points: this.moveBuf.slice(0) });
        this.moveBuf.length = 0;
      }
      // ---- stroke_end ----
      fire('stroke_end', {
        drawing_id: this.drawingId,
        seq: this.strokeSeq,
        total_strokes: this.data.length,   // undo考慮後の番号（= seq - undo累計）
        // len_points: this.pos.length
      });
    },

    toPeninfo() {
      this.$router.push(`/${this.aquarium}/peninfo`);
    },

    getTime() {
      this.startTime = new Date();
    },

    changePartMode() {
      this.isPartMode = !this.isPartMode
      if (this.isPartMode) {
        this.drawpartCtx();
        // 枠などのベースを描いた後、part状態で黒塗りを復元
        this._renderPartMaskFromState();
      }
      // ----ログ mode_change ----
      fire('mode_change', {
        drawing_id: this.drawingId,
        from: this.isPartMode ? 'draw' : 'part',
        to: this.isPartMode ? 'part' : 'draw'
      });
    },

    // setPart() {
    //   var drawImg = this.$refs.drawCanvas;
    //   this.imgURL = drawImg.toDataURL("image/png");
    // },

    // grayPart: function (e) {
    //   console.log("aaa");
    //   // console.log(e);
    //   console.log(e.offsetX, e.offsetY);
    //   let stepX = this.div_rectX / 3
    //   let stepY = this.div_rectY / 3
    //   for (let i = 0; i < 3; i++) {
    //     if ((e.offsetX > i * stepX + this.div_upperLeftX) && (e.offsetX <= (i + 1) * stepX + this.div_upperLeftX)) {
    //       for (let j = 0; j < 3; j++) {
    //         if ((e.offsetY > j * stepY + this.div_upperLeftY) && (e.offsetY <= (j + 1) * stepY + this.div_upperLeftY)) {
    //           this.part[j * 3 + i] = this.part[j * 3 + i] * (-1);
    //           console.log(this.part)
    //         }
    //       }
    //     }
    //   }
    // },

    getUrl() {
      var drawImg = this.$refs.drawCanvas;
      this.imgURL = drawImg.toDataURL("image/png");
      this.endTime = new Date();
      // 1秒のミリ秒の値（1000ミリ秒）
      let sec = 1000;
      this.drawTime = (this.endTime.getTime() - this.startTime.getTime()) / sec;
    },

    async toSearch() {
      this.$store.state.imgURL = this.imgURL;
      this.$store.state.drawTime = this.drawTime;
      this.$store.state.data = this.data;
      this.$store.state.part = this.part;

      // this.$axios
      //   .post("https://dev.pensaku.com/api/penguin_rank_calc.php", { pos: this.plot_vector, part: this.part, aquarium: this.aquarium }, {
      //     headers: {
      //       'Content-Type': 'application/json'
      //     }
      //   })
      //   .then((response) => {
      //     // console.log(response);
      //     this.$store.state.rank_data = response.data;
      //     // alert("success!");
      //     console.log(this.$store.state.rank_data)
      //     this.$router.push(`/${this.aquarium}/ranking`);
      //   })
      //   .catch((error) => {
      //     alert(this.$t('draw.error'));
      //     console.log("err:", error);
      //   });


      // this.$axios
      //   .post("https://dev.pensaku.com/api/pensaku/penguin_rank_calc.php",
      //     { pos: this.plot_vector, part: this.part, aquarium: this.aquarium },
      //     { headers: { 'Content-Type': 'application/json' } }
      //   )
      //   .then((response) => {
      //     const rankedBase = response.data; // ← base形式の配列
      //     this.$store.dispatch('localizeAndSetRankData', rankedBase); // ← 辞書で名前等を付与
      //     this.$router.push(`/${this.aquarium}/ranking`);
      //   })
      //   .catch((error) => {
      //     alert(this.$t('draw.error'));
      //     console.log("err:", error);
      //   });
      try {
        const t0 = performance.now();
        // 1) API呼び出し
        const response = await this.$axios.post(
          "https://dev.pensaku.com/api/pensaku/penguin_rank_calc.php",
          {
            posByN: this.plotVectorsByN,
            partByN: this.partByN,
            pos: this.plot_vector,
            part: this.part,
            aquarium: this.aquarium
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        const latency = Math.round(performance.now() - t0);

        // 2) locale辞書がまだならロード
        if (!this.$store.state.penguinLocaleDict) {
          await this.$store.dispatch('loadPenguinLocale', this.$i18n.locale);
        }

        // 3) base → ローカライズして store へ
        const baseRank = response.data; // 並び替え済み
        const loc = localStorage.getItem('locale') || this.$i18n.locale || 'ja';
        if (this.$store.state.localeStamp !== loc) {
          await this.$store.dispatch('loadPenguinLocale', loc);
        }
        await this.$store.dispatch('localizeAndSetRankData', baseRank);

        //  一意の search_id を生成
        const searchId = crypto.randomUUID();
        // ---- ログ search ----
        const ev = fire('search', {
          drawing_id: this.drawingId,
          algo_ver: process.env.VUE_APP_VERSION || 'dev',
          grid9: this.plot_vector.slice(0),
          grid_n: this.plotVectorsByN,
          total_strokes: this.data.length,
          part: this.part.slice(0),
          part_n: this.partByN,
          latency_ms: latency,
          search_id: searchId,
        });
        // search_id を一時保存（後で Ranking.vue で使う）
        sessionStorage.setItem('last_search_id', ev.event_id);
        this.$store.state.search_id = searchId;

        // 4) 画面遷移（ranking は store.state.rank_data を参照するだけ）
        this.$router.push(`/${this.aquarium}/ranking`);
      } catch (error) {
        alert(this.$t('draw.error'));
        console.log("err:", error);
        fire('error_client', { code: 'search_error', message: String(error), screen: 'draw' });
      }
    },



    // sendDB(path) {
    //   //サーバーに保存する作業
    //   var params = new URLSearchParams();
    //   params.append("name", this.$store.state.name);
    //   params.append("mail", this.$store.state.mail);
    //   params.append("aquarium", this.$store.state.aquarium);
    //   params.append("penname", this.$store.state.penName);
    //   params.append("bandcolor", JSON.stringify(this.$store.state.bandColor));
    //   params.append("image", this.imgURL);
    //   params.append("time", this.drawTime);
    //   params.append("data", JSON.stringify(this.data));

    //   this.$axios
    //     .post("https://dev.pensaku.com/api/penguin_post.php", params)
    //     .then((response) => {
    //       console.log("status:", response.status);
    //       alert("送信しました");
    //     })
    //     .catch((error) => {
    //       alert("エラーが発生しました");
    //       console.log("err:", error);
    //     });

    //   this.dialog = false;
    //   this.$router.push(path);
    // },
  },
  watch: {
    async '$i18n.locale'(loc) {
      if (this.$store.state.localeStamp !== loc) {
        await this.$store.dispatch('loadPenguinLocale', loc);
      }
      const raw = this.$store.state.rank_base_last;
      if (raw?.length) {
        await this.$store.dispatch('localizeAndSetRankData', raw);
      }
    }
  }
};
</script>

<style>
.draw {
  touch-action: manipulation;
}

#canv {
  touch-action: none;
}

.imgBox {
  height: 400px;
  /* 適当な高さを指定 */
  position: relative;
  /* 基準位置とする*/
}

/* .z-1 {
  position: absolute;
  width: 100%;
  height: 100%;
}

.z-2 {
  position: absolute;
  width: 100%;
  height: 100%;
} */
</style>